import React, { useMemo, useState } from 'react'
import './StateBanner.css'

const PRIORITY = {
  urgent: 0,
  ai: 1,
  soft: 2,
  info: 3,
}

function cx(...parts) {
  return parts.filter(Boolean).join(' ')
}

export default function StateBannerStack({ items = [], className = '', maxVisible = 2 }) {
  const [expanded, setExpanded] = useState(false)
  const cap = Math.max(1, Number(maxVisible) || 2)

  const sortedItems = useMemo(
    () => items
      .filter(Boolean)
      .slice()
      .sort((a, b) => (PRIORITY[a.variant] ?? 99) - (PRIORITY[b.variant] ?? 99)),
    [items]
  )

  if (sortedItems.length === 0) return null

  const visible = expanded ? sortedItems : sortedItems.slice(0, cap)
  const overflowCount = Math.max(0, sortedItems.length - visible.length)

  return (
    <div className={cx('state-banner-stack', className)}>
      {visible.map((item) => (
        <React.Fragment key={item.id}>{item.node}</React.Fragment>
      ))}
      {overflowCount > 0 && (
        <button
          type="button"
          className="state-banner-stack__overflow"
          onClick={() => setExpanded(true)}
        >
          +{overflowCount} more
        </button>
      )}
    </div>
  )
}
